import React from 'react'

import { Col } from 'react-styled-flexboxgrid'

export default ({ children, fullWidth }) => (
    <Col xs={12} md={fullWidth ? 12 : 6}>
        {children}
    </Col>
)
